module.exports = __webpack_public_path__ + "img/client_logo_7.11a4eec9.png";